import { TReactEditor, removeNodes, TElement, findNodePath } from "@udecode/plate-core";

export const removePageBreak = (
  element: TElement,
  editor: TReactEditor
): void => {
  const path = findNodePath(editor, element);
  removeNodes(editor, { at: path });
};